export const isValueNegative = (value: unknown): boolean => {
  if (typeof value === 'number') {
    return value < 0
  }
  if (typeof value === 'string') {
    return parseFloat(value.replace(',', '.').replace('—', '-').replace('−', '-')) < 0 // два разных вариант текстовых -
  }
  return false
}
